import React from "react";
import { Box, Heading, Flex, Text, Tag, TagLabel } from "@chakra-ui/react";
import ChartVisualization from "./ChartVisualization";

interface MetricsComparisonChartProps {
  title?: string;
  selectedMetrics?: string[];
  onMetricSelect?: (metric: string) => void;
  effectiveBusinessId?: string;
  effectiveProjectId?: string;
}

const MetricsComparisonChart: React.FC<MetricsComparisonChartProps> = ({
  title = "Metrics Comparison",
  selectedMetrics = ["SOP Deviation", "Deal Sentiment"],
  onMetricSelect,
  effectiveBusinessId,
  effectiveProjectId
}) => {
  return (
    <Box>
      <Heading size="md" mb={4}>
        {title}
      </Heading>
      
      {/* Active metrics display */}
      <Flex p={4} mb={4} bg="gray.50" borderRadius="md" justifyContent="center" alignItems="center">
        <Tag size="lg" borderRadius="full" variant="solid" colorScheme="blue" mr={3}>
          <TagLabel>{selectedMetrics[0]} (Y-Axis)</TagLabel>
        </Tag>
        <Text fontWeight="bold" mx={2}>vs</Text>
        <Tag size="lg" borderRadius="full" variant="solid" colorScheme="purple" ml={3}>
          <TagLabel>{selectedMetrics[1]} (X-Axis)</TagLabel>
        </Tag>
      </Flex>
      
      <ChartVisualization 
        selectedMetrics={selectedMetrics} 
        effectiveBusinessId={effectiveBusinessId}
        effectiveProjectId={effectiveProjectId}
      />
    </Box>
  );
};

export default MetricsComparisonChart; 